import * as React from "react";
import styled from "styled-components";

import { IconCaret } from "../../../../components/atoms";
import { Input } from "../../../../components/molecules/input";

import { SelectorList } from "../selector-list";

interface IProps {
  active: boolean;
  className?: string;
  defaultScrollText?: string;
  disabled?: boolean;
  iconElement?: JSX.Element;
  inputRef: React.RefObject<HTMLInputElement>;
  isItemsLoading?: boolean;
  isTyped?: boolean;
  itemKey?: string;
  itemName?: string;
  items: (object | string)[];
  listRef: React.RefObject<HTMLElement>;
  onBlur(): void;
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
  onClick(): void;
  onFocus(): void;
  onSelect(props: object): void;
  placeholder: string;
  selectedText?: string;
  disabledItems?: string[];
  isDisabled?: boolean;
  children?: React.ReactNode;
}

const SelectorWrapper = styled.div`
  position: relative;

  input {
    transition: none;

    &:read-only,
    &:not(:disabled) :read-only {
      cursor: pointer;
    }

    &.active {
      border-radius: 20px 20px 0 0;
    }
  }
`;

const SelectorCaret = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  right: 15px;
  width: 9px;
  transform: translate(0, -50%);
  pointer-events: none;
`;

const Selector: React.FC<IProps> = (props) => {
  let isNotEmptyChildren = false;
  React.Children.map(props.children, (child) => {
    if (child !== null) {
      isNotEmptyChildren = true;
    }
  });

  return (
    <SelectorWrapper className={props.className}>
      <Input
        iconElement={props.iconElement}
        innerRef={props.inputRef}
        inputStyle="round"
        onBlur={props.onBlur}
        onChange={props.onChange}
        onClick={props.disabled || props.isTyped ? undefined : props.onClick}
        onFocus={props.disabled || !props.isTyped ? undefined : props.onFocus}
        placeholder={props.placeholder}
        readOnly={!props.isTyped}
        className={`${props.active ? "active" : ""}`}
        disabled={props.isDisabled}
      >
        {props.active &&
          (props.items.length > 0 ||
            isNotEmptyChildren ||
            props.isItemsLoading) && (
            <SelectorList
              defaultScrollText={props.defaultScrollText}
              highlight={props.selectedText}
              innerRef={props.listRef}
              isItemsLoading={props.isItemsLoading}
              itemKey={props.itemKey}
              itemName={props.itemName}
              items={props.items}
              disabledItems={props.disabledItems}
              onSelect={props.onSelect}
            >
              {props.children}
            </SelectorList>
          )}
      </Input>
      {!props.isTyped && (
        <SelectorCaret>
          <IconCaret />
        </SelectorCaret>
      )}
    </SelectorWrapper>
  );
};

export { Selector };
